import { isNil } from 'lodash';
import * as orderActionService from 'services/orderActionService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWROrderActionsData = Awaited<
  ReturnType<typeof orderActionService.getOrderActionsAsync>
>;

const useOrderActions = (
  orderId: number,
  load = true
): SWRResponse<SWROrderActionsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_ACTIONS_ENDPOINT, orderId] : null,
    async ([_, params]) => await orderActionService.getOrderActionsAsync(params)
  );

export const SWR_ORDER_ACTIONS_ENDPOINT = 'order-actions';
export default useOrderActions;
